export const API_ENDPOINTS = {
    EMPDETAILS: {
      FETCH: '/empdetails/fetch',
      EMPDETAILSEARCH: '/empdetails/empdetailsearch',
      GET: '/empdetails/get',
      CREATE: '/empdetails/create',
      UPDATE: '/empdetails/update',
      DELETE: '/empdetails/delete',
      CAPTURE: '/empdetails/capture',
      MERGE:  '/empdetails/merge',
      ASSIGN: '/empdetails/assign',
      IMPORT: '/empdetails/import',
      FETCHASSIGN: '/empdetails/fetchassign',
      EMPDETAILASSIGNSEARCH: '/empdetails/empdetailassignsearch',
      GETS:'/empdetails/gets',
      GETASSIGNEDIDEMPDETAILS:'/empdetails/getassignedidempdetailsearch',
      OVERRIDE: '/empdetails/override',
      DELTACHANGE: '/empdetails/deltachange',
      TERMINATIONFETCH: '/empdetails/terminationview',
      TERMINATE: '/empdetails/terminate',
      TERMINATIONFETCHSEARCH: '/empdetails/terminationviewsearch',
      TRANSFERFETCH: '/empdetails/transferview',
      TRANSFERFETCHSEARCH: '/empdetails/transferviewsearch' ,
      TRANSFEREMP: '/empdetails/transferemp',
      TRANSFERORG: '/empdetails/transferorg',
      CLEARDATA: '/empdetails/cleardata'
    },
    REPORTS:{
      FETCH: '/empdetails/getreports'
    },
    DASHBOARD:{
      FETCHCHARTDATA: '/empdetails/getdashboardchartdata',
      FETCHCARDDATA: '/empdetails/getdashboardcarddata'
    }
  };